import api from '@/utils/api';

const state = {};
const mutations = {};

const getters = {};
const actions = {

  // 用户文件告警列表
  async api_file_trace_query_file(_commit, params) {
    return api.get('/api/file_trace/query_file', {params: params});
  },
  async api_file_trace_query_file_detail(_commit, params) {
    return api.get('/api/file_trace/query_file_detail', {params: params});
  },
  async api_file_trace_file_detail_report(_commit, params) {
    return api.post('/api/file_trace/file_detail_report', params);
  },
};

export default {
  state,
  mutations,
  getters,
  actions
};
